import { subscriptionPingsConstants } from "../constants/subscription_pings_constants"

const initialData = {
    loading: false,
    error: null,
    subscription_ping: null
}
export function subscription_ping(state = initialData, action){
    switch(action.type){
        case subscriptionPingsConstants.SUBSCRIPTION_PING:
            return {
                ...state,
                loading: true,
                error: null
            }
        case subscriptionPingsConstants.SUBSCRIPTION_PING_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            }
        case subscriptionPingsConstants.SUBSCRIPTION_PING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case subscriptionPingsConstants.SUBSCRIPTION_PING_ADD:
            return {
                ...state,
                subscription_ping: action.payload,
                loading: false,
                error: null
        }

        case subscriptionPingsConstants.SUBSCRIPTION_PING_LOADING:
            return {
                ...state,
                loading: true
            }

        case subscriptionPingsConstants.SUBSCRIPTION_PING_LOADED:
            return {
                ...state,
                loading: false
            }
        case subscriptionPingsConstants.SUBSCRIPTION_PING_RESET:
            return initialData
        default:
            return state
    }
}